import React from "react";

// Material UI
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const LoginLogsHeader = () => {
  const headCells = [
    { id: "Access Date", numeric: false, label: "Access Date" },
    { id: "IP Address", numeric: false, label: " IP Address" },
  ];

  return (
    <TableHead>
      <TableRow className="header">
        {headCells.map(({id, label}) => (
          <TableCell
            key={id}
            className="headerText"
            align="center"
            padding="normal"
            size="medium"
          >
            {label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default LoginLogsHeader;
